import React, { Component } from 'react';
import { Wrapper } from './style';

class Input extends Component {
  handleKeyPress = e => {
    const { onKeyPress } = this.props;

    onKeyPress && onKeyPress(e);
  };

  render() {
    const { className, autofocus = false, ...rest } = this.props;

    return (
      <Wrapper className={className}>
        <input
          {...rest}
          onKeyPress={this.handleKeyPress}
          type="search"
          autoFocus={autofocus}
        />
      </Wrapper>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js